// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Neon Metropolis Universe Configuration Index
 * 
 * Exports all configuration modules for the cyberpunk universe.
 */

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { NeonMetropolisAliensPlanets } from './AliensConfig.js';

export const universeNeonMetropolis = {
  id: 'neonmetropolis',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: NeonMetropolisAliensPlanets
};

export default universeNeonMetropolis;